/**
 * Internet Explorer unterstützt andere Tastatur-Codewerte
 */
export const KeyboardCodes = {
    up: 38,
    down: 40,
    escape: 27,
    enter: 13,
    tab: 9,
    space: 32,
    backspace: 8
};
